import { useFieldArray, useForm } from 'react-hook-form';
import { useScheduleContext } from '@/pages/Schedule/contexts';
import {
  Button,
  Flex,
  HStack,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
} from '@/ui';
import { FormField } from './FormField';
import { useFormSubmit } from './hooks';
import { useMemberModal } from './store';

export const MemberModal = () => {
  const { isOpen, close } = useMemberModal();
  const { schedule } = useScheduleContext();
  const { submit, isPending } = useFormSubmit();
  const form = schedule?.memberForm;
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      field: form?.fields.map((field) => ({
        fieldId: field.id,
        value: '',
      })),
    },
  });

  const { fields } = useFieldArray({
    control,
    name: 'field',
  });

  if (!form) {
    return null;
  }

  return (
    <Modal isCentered isOpen={isOpen} size="xl" onClose={() => close('cancel')}>
      <ModalOverlay />

      <ModalContent
        as="form"
        p="6"
        onSubmit={handleSubmit((values) => {
          if (values.field) {
            submit(values.field, {
              onSuccess: () => close('submit'),
            });
          }
        })}
      >
        <ModalBody as={Flex} direction="column" gap="4">
          <VStack align="flex-start" mb="6" spacing="4">
            <Heading as="h2" size="lg">
              {form.title}
            </Heading>
            <Text>{form.description}</Text>
          </VStack>

          <VStack align="flex-start" gap="4">
            {fields.map((field, index) => (
              <FormField
                error={errors.field?.[index]?.value?.message}
                field={form.fields[index]}
                key={field.id}
                {...register(`field.${index}.value`, {
                  required: 'Field is required',
                })}
              />
            ))}
          </VStack>
        </ModalBody>

        <ModalFooter as={HStack} gap={3}>
          <Button variant="secondary" onClick={() => close('cancel')}>
            Cancel
          </Button>
          <Button isLoading={isPending} type="submit">
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
